<template>
  <base-modal
    id="settings"
    title="Settings"
    :show="show"
    size="modal-md"
    @closed="$router.push({ name: 'PageEditor'})"
  >
    {{ settings }}
    <template v-for="(setting, index) in settings">
      <div
        :key="index"
        class="form-group row mb-0"
        :class="{'border-bottom': index != (settings.length - 1)}"
      >
        <label class="col-4 col-form-label">{{ setting.name }}</label>
        <div class="col-8">
          <input
            v-if="setting.type == 'color'"
            type="color"
            class="form-control border-0"
            value=""
          >
          <input
            v-if="setting.type == 'checkbox'"
            type="checkbox"
            value=""
          >
        </div>
      </div>
    </template>

    <template slot="footer">
      <button class="btn btn-primary">
        Save
      </button>
    </template>
  </base-modal>
</template>
<script>
/**
 * @deprecated
 * Note: This is a legacy component. It is not used anymore.
*/
import { mapActions } from 'vuex';

export default {
  name: 'PageSettingsEntry',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // settings: [
      //   {
      //     name: 'Background',
      //     type: 'color'
      //   },
      //   {
      //     name: 'Add Signature',
      //     type: 'checkbox'
      //   }
      // ]
    };
  },
  methods: {
    ...mapActions('entries', ['fetchData']),
  },
  computed: {
    settings: {
      get() {
        return this.$store.state.entries.settings;
      },
      set(value) {
        return this.$store.commit('entries/updateSettings', value);
      },
    },
  },
};
</script>
